import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { IGenericFlagMgt } from '@blcloud/bl-datamodel';
import * as Cookies from 'js-cookie';
import { Const } from '@blcloud/bl-common';
import { GenericFlagMgtResource, UserLoginInfoResource } from '@blcloud/bl-ng-resource';
import { Rules } from '@blcloud/bl-ng-ui-component';

@Injectable()
export class LoginPageService {

  /**
   * コンストラクタ
   * @param genericFlagMgtResource 汎用フラグ管理サービス
   * @param userLoginInfoResource 利用者ログイン情報リソース
   */
  constructor(
    private genericFlagMgtResource: GenericFlagMgtResource,
    private userLoginInfoResource: UserLoginInfoResource,
  ) {
  }

  /**
   * getFlag
   */
  getFlag(key: string, fnc: (res: IGenericFlagMgt) => void) {
    this.genericFlagMgtResource.getById(key, {subject: 'common'}
    ).subscribe((res) => {
      fnc(res);
    }, (err) => {
      fnc((<IGenericFlagMgt>{
        blTenantId: '',
        genericFlagKey: key,
        genericFlagValue: err.status !== 404
      }));
    });
  }

  setLoginCookie(res: string[]): void {
    // 第二レベルドメインがない想定でドメイン名を第三レベルドメインで抜き出す
    const dns = document.domain.split('.').slice(-2).join('.');
    const ok = dns.match(/bcloud.jp$/) ? true : false; // 本番のみtrueとする
    // 認証情報のセット
    Cookies.set(Const.Cookie.Key.ACCESS_TOKEN, res[0], {secure: ok});
    Cookies.set(Const.Cookie.Key.ID_TOKEN, res[1], {secure: ok});
  }

  clearLoginCookie(): void {
    Cookies.remove(Const.Cookie.Key.ACCESS_TOKEN); // ログイン画面で矯正削除
    Cookies.remove(Const.Cookie.Key.ID_TOKEN); // ログイン画面で矯正削除
  }

  rules(): Observable<Rules[]> {
    return this.userLoginInfoResource.getRules<Rules[]>({ subject: 'common', apiOptions: { anonymous: true } });
  }
}



// WEBPACK FOOTER //
// ./src/app/page/login-page/login-page.service.ts